import React from 'react';
import { PolaGroupSection } from '../components/PolaGroupSection';
import { SolutionsSection } from '../components/SolutionsSection';
export function AboutPage() {
  return <div className="pt-28" data-id="element-838">
      <PolaGroupSection data-id="element-839" />
      <SolutionsSection data-id="element-840" />
    </div>;
}